import React, { useState, useEffect } from 'react';
import './emps-performance.css';
import { GrDocumentPerformance } from "react-icons/gr";
import { FaUsers } from "react-icons/fa";
import { IoEye } from "react-icons/io5";
import { Button, ButtonGroup, Dropdown, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Dummy data for demonstration
const mockPerformanceData = Array.from({ length: 30 }, (_, index) => ({
  id: index + 1,
  name: `Employee ${index + 1}`,
  role: `Role ${index + 1}`,
  amount: `$${(index + 1) * 1000}`
}));

export default function Performance() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Calculate total entries and total pages
  const totalEntries = mockPerformanceData.length;
  const totalPages = Math.ceil(totalEntries / rowsPerPage);

  // Fetch data (simulated with setTimeout)
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const startIndex = (currentPage - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
      setData(mockPerformanceData.slice(startIndex, endIndex));
      setLoading(false);
    }, 500); // Simulate a 0.5-second delay
  }, [currentPage]);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className='container-fluid'>
      <div>
        <h1 className='performance-title'><GrDocumentPerformance /> Employee Performance</h1>
        <hr />
        <h1 className='performance-subtitle'><FaUsers /> Employees</h1>
        <hr />
      </div>
      <div className='performance-container'>
        <div className='performance-actions'>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary"style={{marginLeft:0}}>Show Entries</Button>
                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                <Dropdown.Menu>
                  <Dropdown.Item as="button">10</Dropdown.Item>
                  <Dropdown.Item as="button">25</Dropdown.Item>
                  <Dropdown.Item as="button">50</Dropdown.Item>
                  <Dropdown.Item as="button">100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end">
              <div className='performance-search-container'>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="performance-search"
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className='table table-striped table-style'>
              <thead className="performance-table-header">
                <tr className="table-header">
                  <th>SR</th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id} style={{ textAlign: 'center' }}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.role}</td>
                    <td>{item.amount}</td>
                    <td>
                      <Link to='/edit-atd'>
                        <Button variant='warning' size='sm'>
                          <IoEye />
                        </Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className='performance-footer'>
                <tr className="performance-table-footer">
                  <td>Total</td>
                  <td colSpan="4">0</td>
                </tr>
              </tfoot>
            </table>
          )}
          <div className="entries-pagination-container">
            <p className="showing-entries">
              Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
              {Math.min(currentPage * rowsPerPage, totalEntries)} of{" "}
              {totalEntries} entries
            </p>

            <nav className="pagination-container">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>
                {pageRange().map((page) => (
                  <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}
